import { FormInstance, RuleObject } from 'antd/lib/form';
import getFormatMessage from '../../locales/get-format-message';
import { randomBytes } from 'crypto';

// 注册密码,忘记密码满足规则:至少包含字母、数字与符号3种类型中的2种
export function hasValidCharacterTypes(password: string): boolean {
  const reg = /^[a-zA-Z0-9!@#$%^&*()+=<>?/.,~_-]+$/;
  const characterTypes: { [key: string]: RegExp } = {
    case: /[a-zA-Z]/,
    number: /\d/,
    symbol: /[!@#$%^&*()+=<>?/.,~_-]/,
  };
  const keys = Object.keys(characterTypes);
  let count = 0;
  for (const type of keys) {
    if (characterTypes[type].test(password)) {
      count += 1;
    }
  }
  return count >= 2 && reg.test(password);
}

export const getPasswordRule = (form: React.RefObject<FormInstance<any>>) => {
  return (
    rule: RuleObject,
    value: string,
    callback: (error?: string | undefined) => void
  ) => {
    if (!value) {
      callback(getFormatMessage('can_not_empty'));
      return;
    }
    if (value.length < 10) {
      callback(getFormatMessage('use_least_10'));
      return;
    }
    if (value.length > 72) {
      callback(getFormatMessage('max_72'));
      return;
    }
    if (value.includes(' ')) {
      callback(getFormatMessage('no_spaces'));
      return;
    }
    if (!hasValidCharacterTypes(value)) {
      callback(getFormatMessage('please_stronger_password'));
      return;
    }

    const currentPassword = form.current?.getFieldValue('currentPassword');
    if (currentPassword === value) {
      callback(getFormatMessage('no_different_password'));
      return;
    }

    callback();
  };
};

export const emailRule = (
  rule: RuleObject,
  value: string,
  callback: (error?: string | undefined) => void
) => {
  const reg = new RegExp(
    '^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$'
  );
  if (value && !reg.test(value.trim())) {
    callback(getFormatMessage('use_correct_email_format'));
  } else {
    callback();
  }
};

export const generateStrongPassword = (length = 12): string => {
  if (length < 4) {
    throw new Error(
      'password length should be at least 4 to include all character types.'
    );
  }

  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const specials = '_-@';

  const allChars = upper + lower + digits + specials;

  // 确保每类字符至少一个
  const passwordChars = [
    upper[randomBytes(1)[0] % upper.length],
    lower[randomBytes(1)[0] % lower.length],
    digits[randomBytes(1)[0] % digits.length],
    specials[randomBytes(1)[0] % specials.length],
  ];

  const remainingLength = length - passwordChars.length;
  const bytes = randomBytes(remainingLength);
  for (let i = 0; i < remainingLength; i++) {
    passwordChars.push(allChars[bytes[i] % allChars.length]);
  }

  // 打乱顺序
  for (let i = passwordChars.length - 1; i > 0; i--) {
    const j = randomBytes(1)[0] % (i + 1);
    [passwordChars[i], passwordChars[j]] = [passwordChars[j], passwordChars[i]];
  }

  return passwordChars.join('');
};
